// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FieldGroup from '../../FieldGroup';
import Checkbox from '../Checkbox';

export default class ContactFieldGroup extends Component {
  render() {
    const {
      handleChange,
      mailing,
      whatsapping,
      phoning,
      customClasses,
      showError = false,
    } = this.props;

    const hasError = showError && !mailing && !whatsapping && !phoning;

    return (
      <FieldGroup
        customClasses={classNames('contact-field-group', customClasses)}
      >
        <legend className="contact-field-group__label">
          Quero receber contato por:
        </legend>
        <div className="contact-field-group__wrapper">
          <Checkbox
            label="E-mail"
            name="mailing"
            value={mailing}
            isChecked={mailing}
            handleChange={handleChange}
          />
          <Checkbox
            label="WhatsApp"
            name="whatsapping"
            value={whatsapping}
            isChecked={whatsapping}
            handleChange={handleChange}
          />
          <Checkbox
            label="Telefone"
            name="phoning"
            value={phoning}
            isChecked={phoning}
            handleChange={handleChange}
          />
        </div>
        {hasError && (
          <span className="contact-field-group__error">
            Pelo menos uma opção precisa ser selecionada.
          </span>
        )}
      </FieldGroup>
    );
  }
}

ContactFieldGroup.propTypes = {
  handleChange: PropTypes.func,
  mailing: PropTypes.bool,
  whatsapping: PropTypes.bool,
  phoning: PropTypes.bool,
  customClasses: PropTypes.string,
  showError: PropTypes.bool,
};
